import Currency from '../currency/currency';

interface Props {
  price: number;
  priceBeforeDiscount: number | null;
  textFree?: boolean;
  wrapperClassName?: string;
}

export const DiscountedPrice = ({
  priceBeforeDiscount,
  price,
  textFree = false,
  wrapperClassName,
}: Props) => {
  const isEffectivelyFree = Boolean(
    price === 0 || (price !== undefined && price < 0.01),
  );

  return (
    <div className={wrapperClassName}>
      {priceBeforeDiscount !== price && priceBeforeDiscount && (
        <Currency
          amount={priceBeforeDiscount}
          className="text-muted text-small line-through"
        />
      )}
      <Currency amount={price} textFree={isEffectivelyFree && textFree} />
    </div>
  );
};
